import { useState } from "react";
import ExcursionBusesTable from "../components/ExcursionBusesTable";
import ExcursionTable from "../components/ExcursionTable";
import PageDocumentation from "../components/PageDocumentation";

function Excursions() {
  const [selectedExcursion, setSelectedExcursion] = useState(null);

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-semibold">Excursiones</h1>
        <PageDocumentation docKey="excursions" />
      </div>
      {!selectedExcursion && (
        <ExcursionTable
          onExcursionSelect={(excursion) => {
            setSelectedExcursion(excursion);
          }}
        />
      )}

      {selectedExcursion && (
        <ExcursionBusesTable
          onBack={() => {
            setSelectedExcursion(null);
          }}
          selectedExcursionId={selectedExcursion.id}
        />
      )}
    </div>
  );
}

export default Excursions;
